import React, { useEffect, useState } from "react";
import { Col, Form, Radio, Row } from "antd";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import {
  showNotitfication,
} from "../../../../components/utils/utils";
import TextArea from "antd/es/input/TextArea";
import Inputs from "../../../../biblio/Inputs/Inputs";
import { getTicketsTypes } from "../../../../apis/actions/contact.actions";
import { setResIds, setResModel } from "../../../../apis/slices/ratingSlice";
import {
  addcontactUsRequest,
  getContactUsList,
} from "../../../../apis/actions/recipient.actions";
import { handleFileChange } from "../fileUtils";

interface Props {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible: boolean;
}

const ContactUsModal = ({ setIsModalVisible, isModalVisible }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { ticketsTypes } = useSelector((state: RootState) => state.contact);
  useEffect(() => {
    dispatch(getTicketsTypes());
  }, [dispatch]);

  const onFinish = async () => {
    try {
      await form.validateFields();
      const FormValues = form.getFieldsValue();
      setLoading(true);
      const suggestionsComplaintsData = {
        ...FormValues,
      };
      const data = (await dispatch(
        addcontactUsRequest(suggestionsComplaintsData)
      )) as any;
      const success = data?.payload?.data?.result;
      if (success?.code === 200) {
        dispatch(setResModel(success?.res_model));
        dispatch(setResIds([success?.ticket_id]));
        showNotitfication(success?.message, "success", dispatch);
        dispatch(getContactUsList({limit : 8 , page : 1}));
        form.resetFields();
        setIsModalVisible(false);
      } else {
        showNotitfication(success?.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ModalComponent
        destroyOnClose
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={700}
        modalStyle={{ top: 200 }}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout"> إنشاء طلب </p>
        </Row>
        <Form form={form}>
          <Row
            gutter={16}
            align={"middle"}
            dir="rtl"
            style={{ marginTop: "3rem" }}
          >
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="ticket_type_id"
                className="takaful--label-inputs"
                label="نوع الطلب:"
                wrapperCol={{
                  xxl: 18,
                  xl: 18,
                  lg: 16,
                  md: 16,
                  sm: 16,
                  xs: 16,
                }}
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelAlign="left"
                labelCol={{
                  className: "takaful--label-style",
                  xxl: 8,
                  xl: 8,
                  lg: 8,
                  md: 8,
                  sm: 8,
                  xs: 8,
                }}
              >
                <Radio.Group style={{ marginLeft: "0.9rem" }}>
                  {ticketsTypes.map((ticketType: any) => (
                    <Radio
                      key={ticketType.id}
                      className="takaful--tickets-radio"
                      value={ticketType.id}
                    >
                      {ticketType.name}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} dir="rtl" style={{ marginTop: "1rem" }}>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="name"
                label="عنوان الطلب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>

            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="attachment_ids"
                label="مرفقات"
                className="takaful--label-inputs"
                labelCol={{ className: "takaful--label-style" }}
              >
                <UploadInput
                  text="مرفقات"
                  icon={<UploadOutlined />}
                  multiple={true}
                  onChange={(fileList) =>
                    handleFileChange(
                      fileList,
                      form.setFieldsValue,
                      "attachment_ids"
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} dir="rtl">
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                name="description"
                label="تفاصيل الطلب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <TextArea
                  className="takaful--suggestions-complaints-textarea"
                  rows={3}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row
            justify={"end"}
            dir="rtl"
            style={{ width: "100%", paddingTop: "1rem" }}
          >
            <PrimaryButton
              onClick={onFinish}
              title="إرسال الطلب"
              disabled={loading}
              loading={loading}
            />
          </Row>
        </Form>
      </ModalComponent>
    </>
  );
};

export default ContactUsModal;
